<template>
  <div class="a7-painel-analise-list-desktop">
    <div class="body-filters">
      <a7-painel-analise-parameter v-model="localFilters"/>
    </div>
    <gw-card class="a7-card data-table">
      <div slot="body" class="body-data-table">
        <gw-tree-table :data="itens"
            @selectedEntity="selectEntity"
            child-nodes="itens">
            <gw-column title="Medida" :width="320">
              <template slot-scope="{row,value}" >
                <span>
                  {{row.descricao}}
                </span>
                <div v-if="hasValueOrIsZero(row.detalheAtual)
                  || hasValueOrIsZero(row.detalheAnterior)">
                  <br>
                </div>
              </template>
            </gw-column>

            <gw-column title="Evolução" :width="tamanhoColuna">
              <template slot-scope="{row,value,selected}">
                <div
                  :class="formataCor(row.evolucao, row.melhorResultado)"
                  v-if="hasValueOrIsZero(row.evolucao)">
                  <span>
                    {{formataValor(Math.abs(row.evolucao), '%')}}
                  </span>
                  <gw-icon :icon="defineIcone(row.evolucao, row.melhorResultado)"/>
                </div>
                <div v-else>
                  <br>
                </div>
                <div v-if="hasValueOrIsZero(row.detalheAtual)
                  || hasValueOrIsZero(row.detalheAnterior)">
                  <br>
                </div>
              </template>
            </gw-column>

            <gw-column title="Atual" :width="tamanhoColuna">
              <template slot-scope="{row,value}" v-if="hasValueOrIsZero(row.atual)">
                <span>
                  {{formataValor(row.atual, row.formato)}}
                </span>
                <span v-if="hasValueOrIsZero(row.detalheAtual)">
                  <br>
                  <span>
                    {{formataValor(row.detalheAtual, row.detalheFormato)}}
                  </span>
                </span>
              </template>
            </gw-column>

            <gw-column title="Anterior" :width="tamanhoColuna">
              <template slot-scope="{row,value}" v-if="hasValueOrIsZero(row.anterior)">
                <span>
                  {{formataValor(row.anterior, row.formato)}}
                </span>
                <span v-if="hasValueOrIsZero(row.detalheAnterior)">
                  <br>
                  <span>
                    {{formataValor(row.detalheAnterior, row.detalheFormato)}}
                  </span>
                </span>
              </template>
            </gw-column>

            <gw-column title="Diferença" :width="tamanhoColuna">
              <template slot-scope="{row,value}" v-if="hasValueOrIsZero(row.diferenca)">
                <div>
                  <span :class="formataCor(row.diferenca, row.melhorResultado)">
                    <span>
                      {{formataValor(Math.abs(row.diferenca), row.formato)}}
                    </span>
                    <gw-icon :icon="defineIcone(row.diferenca, row.melhorResultado)"/>
                  </span>
                  <span v-if="hasValueOrIsZero(row.detalheDiferenca)">
                    <br>
                    <span>
                      {{formataValor(row.detalheDiferenca, row.detalheFormato)}}
                    </span>
                  </span>
                </div>
              </template>
            </gw-column>
        </gw-tree-table>
      </div>
    </gw-card>
  </div>
</template>

<script>
import {
  GwCard,
  GwColumn,
  GwTreeTable,
  Formatters,
  GwIcon,
  GwModalDialog,
  GwButton
} from 'guaxinim-web'
import A7PainelAnaliseParameter from './A7PainelAnaliseParameter'
import A7PainelAnaliseFormatacao from './A7PainelAnaliseFormatacao'

export default {
  name: "a7-painel-list-desktop",
  components: {
    GwCard,
    GwColumn,
    GwTreeTable,
    Formatters,
    GwIcon,
    GwModalDialog,
    GwButton,
    A7PainelAnaliseParameter
  },
  props: {
    itens: {
      type: Array,
      required: true
    },
    value: {
      type: Object
    }
  },
  data: () => ({
    selectedEntity: null,
    localFilters:{},
    showModal:false,
    tamanhoColuna: 130
  }),
  methods: {
    selectEntity(entity) {
      this.selectedEntity = entity
    },
    emitInput() {
      this.$emit('input', this.localFilters)
    },
    hasValueOrIsZero(value) {
      return (value || value === 0)
    },
    defineIcone: A7PainelAnaliseFormatacao.defineIcone,
    formataCor: A7PainelAnaliseFormatacao.formataCor,
    formataValor: A7PainelAnaliseFormatacao.formataValor
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.localFilters = value
      }
    },
    localFilters() {
      this.emitInput()
    }
  }
}
</script>

<style lang="scss">
@import 'guaxinim-web/src/css/color-palette.scss';
.a7-painel-analise-list-desktop .gw-table-cell-selected{
  color: $black!important;
  background-color: $grey-lighter!important;
}
.a7-painel-analise-list-desktop .modal-dialog {
  max-width: 400px;
}
</style>

<style lang="scss" scoped>
@import './A7PainelAnaliseFormatacao';
$headerSize: 56px;
$tamanhoTelaSemBarra: calc(100vh - #{$headerSize});
$tamanhoUtil: 850px;

.a7-painel-analise-list-desktop{
  height: $tamanhoTelaSemBarra;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 15%;
}
.data-table{
  margin-top: 10px;
}
.a7-card {
  width: 100%;
  &.data-table {
    flex-grow: 1;
    width: $tamanhoUtil;
  }
}

.body-data-table{
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
}

.body-filters{
  margin-top: 10px;
  width:  $tamanhoUtil;
}

</style>
